export default function(initialObj) {
  return Object.entries(initialObj).reduce((obj, [key, val]) => {
    if (val) {
      obj[key] = val
    }
    return obj
  }, {})
}
